export function mapGraphMessageToCommunicationBase(message) {
    const addr = message.from?.emailAddress?.address ?? 'unknown@unknown';
    const name = message.from?.emailAddress?.name ?? addr;
    return {
        graphMessageId: message.id,
        sender: { name, address: addr },
        subject: message.subject ?? '(no subject)',
        bodyPreview: message.bodyPreview ?? '',
        receivedDateTime: message.receivedDateTime ?? new Date().toISOString(),
        internetMessageId: message.internetMessageId ?? `synthetic:${message.id}`,
    };
}
